import { createFileRoute } from '@tanstack/react-router';
import { OfficeMessagesPage } from '@/features/work-orders/components/worksheet-detail/OfficeMessagesPage';

export const Route = createFileRoute('/_authenticated/work-orders/$id/worksheets/$worksheetId/messages')({
	component: WorkSheetMessages,
});

function WorkSheetMessages() {
	const { id, worksheetId } = Route.useParams();
	return <OfficeMessagesPage workOrderId={id} worksheetId={worksheetId} />;
}
